import React from "react";

export default function WelcomeIntro() {
  return (
    <div className="flex flex-col items-center">
      <h1 className="text-4xl md:text-6xl font-extrabold text-blue-600 mb-2">ReportMaster</h1>
      <div className="text-xl md:text-2xl text-gray-600 font-medium mb-2">Smart Reports. Instantly.</div>
    </div>
  );
}
